import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loading from "../../components/Loading/Loading";
import AddIcon from "@mui/icons-material/Add";
import TableBadges from "./TableBadges/TableBadges";
import { useDispatch, useSelector } from "react-redux";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { getAllBadgesAPI } from "../../services/badges/badgeService";
import { setListBadges } from "../../redux/slice/badgesSlice";
import ModalBadge from "./ModalBadge";
import { setListMemberships } from "../../redux/slice/membershipsSlice";
import { getAllMembershipsAPI } from "../../services/memberships/membershipService";

const Badges = () => {
  const [loading, setLoading] = useState(true);
  const [showModalBadge, setShowModalBadge] = useState(false);
  const { listBadges } = useSelector((state) => state.badgesReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    const getAllBadges = async () => {
      try {
        const responseBadges = await getAllBadgesAPI();
        // console.log("Lista de logros", responseBadges);
        dispatch(setListBadges({ listBadges: responseBadges }));
        const listMemberships = await getAllMembershipsAPI();
        dispatch(setListMemberships({ listMemberships }));
        setLoading(false);
      } catch (error) {
        const { message } = handleError(error);
        dispatch(setListBadges({ listBadges: [] }));
        setLoading(false);
        toast.error(`No se se pudieron obtener los logros. \n ${message}`);
      }
    };
    getAllBadges();
  }, [dispatch]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <ModalBadge
        open={showModalBadge}
        setOpen={setShowModalBadge}
        isEdit={false}
        setLoading={setLoading}
      />
      <Loading loading={loading} />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Logros</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<AddIcon />}
          onClick={() => {
            setShowModalBadge(true);
          }}
        >
          Agregar Logro
        </Button>
      </Box>
      <TableBadges setLoading={setLoading} rows={listBadges ?? []} />
    </Box>
  );
};

export default Badges;
